import React, { Component } from 'react';
import cx from 'classnames';
import { Field, Form, change, reduxForm } from 'redux-form';
import { lookupTypes } from '../../constants/pnr-lookup-types-enum';

// Decorators
import TranslatedCopy from '../../intl/translated-copy';
import FormInputText from './form-input-text';
import formFieldCopyIDs from '../../constants/form-field-copy-ids';
import { connect } from 'react-redux';

import { HomeE4 } from '../../../routing/urls';
import LoggedBar from './logged-bar';
import pnrLookupValidation from '../../validation/pnr-lookup-validation';
import RenderReservationOrETicketLabel from './header-menu-my-trips-reservation-eticker-label';
import travelerFormOptions from '../../constants/traveler-form-options';
import { chageTouchPointTypeCp } from '../../../redux/actions/change-touch-point-type-cp-creator';
import { retrieveProfileUserAction } from '../../../redux/actions';

const mapStateToProps = state => {
  return {
    country: state.LanguageBundle.country,
    formValues: state.form['MENU_MY_TRIPS'],
    helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
    isSignIn: state.UserProfileSession.isSignIn,
    language: state.Manage.language,
    loadingUserInfo: state.UserProfileSession.loadingUserInfo,
    remainingAttemptsRetrieveProfile: state.UserProfileSession.remainingAttemptsRetrieveProfile,
    storefront: state.Manage.storefront,
    userProfile: state.UserProfileSession.userProfile,
    userToken: state.UserProfileSession.userToken,
  };
};

class HeaderMenuMyTripsPnrLookUpLight extends Component {
  constructor() {
    super();

    this.state = {
      isCheckin: false,
      moreThanOneTrip: false,
      noTrips: false,
      trip: {},
    };

    this.updateWindowDimension = this.updateWindowDimension.bind(this);
    this.handleClick = this.handleClickPnrLookUp.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  componentDidMount() {
    const { dispatch, isSignIn, remainingAttemptsRetrieveProfile } = this.props;

    this.updateWindowDimension();
    window.addEventListener('resize', this.updateWindowDimension);
    dispatch(change('MENU_MY_TRIPS', 'reservationType', travelerFormOptions.RESERVATION_TYPE[0]));
    dispatch(change('MENU_MY_TRIPS', 'programFrequentTraveler', travelerFormOptions.RESERVATION_TYPE[0]));

    if (isSignIn) {
      const { userProfile } = this.props;

      if (!userProfile?.myTrips && remainingAttemptsRetrieveProfile > 0) {
        this.handleCheckInTrips(userProfile);
      } else {
        this.handleUserTrips();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { pnrCollectionModel } = this.props;
    const { typePNRLookUp, actionPnrLookUp } = this.state;
    const isDistinct = pnrCollectionModel !== nextProps.pnrCollectionModel;
    const isFFNLookup = lookupTypes.FREQUENT_FLYER;

    if ( typePNRLookUp === 'MYB' && actionPnrLookUp === 'FREQUENT_FLYER' ) {
      if ( isDistinct ) {
        this.setState({
          isRouteInProces: false,
        });
      }
    } else if (typePNRLookUp === 'CKN' && actionPnrLookUp === 'FREQUENT_FLYER' && isDistinct && isFFNLookup) {
      this.setState({
        isRouteInProces: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { userProfile, remainingAttemptsRetrieveProfile } = this.props;

    if (prevProps.userProfile !== userProfile && remainingAttemptsRetrieveProfile > 0) {
      if (userProfile?.myTrips?._collection?.length >= 0) {
        const myTripsCollection = userProfile?.myTrips?._collection;
        const tripCheckin = [];
        const tripMyb = [];

        myTripsCollection.forEach((item) => {
          item.bookedLegCollection._collection.forEach((segment) => {
            if (segment.manageStatus === 'OPEN' || segment.checkinStatus === 'OPEN') {
              if (segment.checkinStatus === 'OPEN') {
                tripCheckin.push(item);
              } else {
                tripMyb.push(item);
              }
            }
          });
        });

        if (tripCheckin.length > 0) {
          this.setState({ isCheckin: true });

          tripCheckin.forEach((trip) => {
            this.setState({ trip: trip });
          });
        } else if (tripCheckin.length === 0 && tripMyb.length > 0) {
          this.setState({ moreThanOneTrip: true });

          tripMyb.forEach((trip) => {
            this.setState({ trip: trip });
          });
        } else {
          this.setState({ noTrips: true });
        }
      } else {
        this.setState({ noTrips: true });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimension);
  }

  render() {
    const {
      invalid,
      isSignedIn,
      userToken,
    } = this.props;
    const { isCheckin, moreThanOneTrip, noTrips, trip } = this.state;

    const newDesignInput = cx({
      'FormInput-new-design': true,
    });
  
    const searchPnrButtonEnabled = cx({
      'HeaderMenuBook-right-newLook--pnrLookUpLight--form--searchPnrButtonEnabled': !invalid,
      'HeaderMenuBook-right-newLook--pnrLookUpLight--form--searchPnrButtonDisabled': invalid,
    });
  
    return (
      <div className='HeaderMenuBook-right-newLook'>
        {
          isSignedIn &&
          <div className='HeaderMenuBook-right-newLook--banner'>
            <LoggedBar
              userToken={ userToken }
              switchNewLook={ true }
              isCheckin={ isCheckin }
              moreThanOneTrip={ moreThanOneTrip }
              noTrips={ noTrips }
              trip={ trip } />
          </div>
        }
        <div className='HeaderMenuBook-right-newLook--pnrLookUpLight' >
          {
            !isSignedIn &&
            <div className='HeaderMenuBook-right-newLook--pnrLookUpLight--title'>
              <TranslatedCopy copyID='HUB_LOOKUP_TITLE' />
            </div>
          }
          <Form
            className='HeaderMenuBook-right-newLook--pnrLookUpLight--form'
            onSubmit={ (e) => this.handleClickPnrLookUp(e) }  >
            <div className='HeaderMenuBook-right-newLook--pnrLookUpLight--form--input'>
              <Field
                className={ newDesignInput }
                component={ FormInputText }
                handleError={ this.handleError }
                isRequired={ true }
                labelCopyID={ RenderReservationOrETicketLabel() }
                maxLength={ 13 }
                minLength={ 6 }
                name='ticketNumber'
                shouldSetErrorWidth={ true }
                switchNewLook={ true }
                validateNoSpecialCharsOnChange={ true }
              />
            </div>
            <div className='HeaderMenuBook-right-newLook--pnrLookUpLight--form--input'>
              <Field
                className={ newDesignInput }
                component={ FormInputText }
                handleError={ this.handleError }
                isRequired={ true }
                labelCopyID={ formFieldCopyIDs.lastName }
                maxLength={ 30 }
                minLength={ 2 }
                name='lastName'
                shouldSetErrorWidth={ true }
                switchNewLook={ true }
                validateNoSpecialCharsOnChange={ true } />
            </div>
            <button type={ 'submit' } className={ searchPnrButtonEnabled } >
              <TranslatedCopy copyID='HUB_SEARCH_BUTTON' />
            </button>
          </Form>
          {
            !isSignedIn &&
            <div className='HeaderMenuBook-right-newLook--pnrLookUpLight--notHaveAccount'>
              <p className='HeaderMenuBook-myTrips--signIn HeaderMenuBook-myTrips-tablet--signIn'>
                <TranslatedCopy copyID='APP_SUBMENU_HAVE_TRAVEL' spaceAfter={ true } />
                <button className='Link HeaderMenuBook-myTrips--signIn--linkBlue HeaderMenuBook-myTrips-tablet--signIn--linkBlue' onClick={ () => { this.handleClickOpenModal('myTripsModal'); } }>
                  <TranslatedCopy
                    copyID='APP_SUBMENU_LOGIN'
                    spaceBefore={ true } />
                </button>
              </p>
            </div>
          }
        </div>
      </div>
    );
  }
  

  handleError(field, error) {
    switch (field) {
      case 'frequentFlyerNumberHM':
        this.setState({ isError: { frequentFlyerNumberHM: error } });
        break;
      case 'ticketNumber':
        this.setState({ isError: { ticketNumber: error } });
        break;
      case 'lastName':
        this.setState({ isError: { lastName: error } });
        break;
      case 'lastNamePvf':
        this.setState({ isError: { lastNamePvf: error } });
        break;
      default:
        break;
    }
  }

  handleClickPnrLookUp(e) {
    e.preventDefault();
    const {
      country,
      formValues: {
        values: {
          lastName,
          ticketNumber,
        },
      },
      language,
    } = this.props;
    const locationMyTripE4 = HomeE4(language, country);
    
    this.setState({
      isRouteInProces: true,
    });

    const host = window.location.hostname;
    window.location.replace(`https://${host}${locationMyTripE4}?last-name=${lastName}&pnr=${ticketNumber}`);
  }

  handleUserTrips() {
    const { userProfile } = this.props;

    if (userProfile.myTrips) {
      if (userProfile?.myTrips?._collection?.length >= 0) {
        const myTripsCollection = userProfile?.myTrips?._collection;
        const tripCheckin = [];
        const tripMyb = [];

        myTripsCollection.forEach((item) => {
          item.bookedLegCollection._collection.forEach((segment) => {
            if (segment.manageStatus === 'OPEN' || segment.checkinStatus === 'OPEN') {
              if (segment.checkinStatus === 'OPEN') {
                tripCheckin.push(item);
              } else {
                tripMyb.push(item);
              }
            }
          });
        });

        if (tripCheckin.length > 0) {
          this.setState({ isCheckin: true });

          tripCheckin.forEach((trip) => {
            this.setState({ trip: trip });
          });
        } else if (tripCheckin.length === 0 && tripMyb.length > 0) {
          this.setState({ moreThanOneTrip: true });

          tripMyb.forEach((trip) => {
            this.setState({ trip: trip });
          });
        } else {
          this.setState({ noTrips: true });
        }
      } else {
        this.setState({ noTrips: true });
      }
    }
  }

  handleCheckInTrips() {
    const { country, dispatch, language, loadingUserInfo, remainingAttemptsRetrieveProfile, userToken } = this.props;

    if (loadingUserInfo || remainingAttemptsRetrieveProfile < 1) {
      return;
    }

    const pos = {
      'language': language,
      'pos': 'WEB',
      'store': country,
    };

    dispatch( retrieveProfileUserAction( userToken, pos ) );
  }

  handleClickOpenModal(typeTouchPoint) {
    const { dispatch, openModalLogin } = this.props;

    dispatch(chageTouchPointTypeCp(typeTouchPoint));

    openModalLogin();
  }

  updateWindowDimension() {
    this.setState({ width: window.innerWidth });
  }
}

HeaderMenuMyTripsPnrLookUpLight = reduxForm({
  form: 'MENU_MY_TRIPS',
  initialValues: {
    lookupType: lookupTypes.TICKET,
  },
  validate: pnrLookupValidation,
})(HeaderMenuMyTripsPnrLookUpLight);

HeaderMenuMyTripsPnrLookUpLight = connect(mapStateToProps)(HeaderMenuMyTripsPnrLookUpLight);

export default HeaderMenuMyTripsPnrLookUpLight;